export default function(state = {}, action){
    switch(action.type){
        case "SET_CALL_FORWARD":
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/callForward.js